import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import { IconArrowLeft, IconArrowRight } from '@xing-com/icons';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXL, spaceXS } from '@xing-com/tokens';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${spaceXS} ${spaceXL};
`;

export const WizardCTAButton = styled(Button).attrs({
  variant: 'primary',
})<{ $isWide?: boolean }>`
  width: ${({ $isWide }) => ($isWide ? '100%' : 'fit-content')};

  @media ${mediaConfined} {
    width: fit-content;
  }
`;

type Props = {
  hasPrevious: boolean;
  isReviewMode: boolean;
  isLoading?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  onReview?: () => void;
};

export const WizardActions: React.FC<Props> = ({
  hasPrevious,
  isReviewMode,
  isLoading = false,
  onBack,
  onNext,
  onReview,
}) => {
  const hasBackButton = hasPrevious && !isReviewMode;
  const hasNextButton = !isReviewMode;

  return (
    <Container>
      {hasBackButton ? (
        <TextButton icon={IconArrowLeft} onClick={onBack} disabled={isLoading}>
          <FormattedMessage id="JOBS_APPLY_WIZARD_BUTTON_BACK" />
        </TextButton>
      ) : null}
      {hasNextButton ? (
        <WizardCTAButton
          disabled={isLoading}
          icon={IconArrowRight}
          onClick={onNext}
          $isWide={!hasPrevious}
        >
          <FormattedMessage id="JOBS_APPLY_WIZARD_BUTTON_NEXT" />
        </WizardCTAButton>
      ) : null}
      {isReviewMode ? (
        <WizardCTAButton
          $isWide
          icon={IconArrowRight}
          onClick={onReview}
          disabled={isLoading}
        >
          <FormattedMessage id="JOBS_APPLY_WIZARD_BUTTON_REVIEW" />
        </WizardCTAButton>
      ) : null}
    </Container>
  );
};
